import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { SCREEN_ID_UTILITY_SETUP_SIGNUP } from 'client/constants/screenIds';

import {
  SR_API_ACTION_ADDRESS_REGISTER,
  SR_API_ACTION_UTILITY_USER_SIGNUP,
} from 'api/utilityActionTypes';

import { hasRoleRenter } from 'common/utility/userRoles';

import { UTILITY_PARTNER_CUSTOMER_TYPE_TENANT_SCREENING } from 'common/utility/constants';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withLocationQuery from 'client/helpers/withLocationQuery';
import withScrollToTop from 'client/helpers/withScrollToTop';

import branch from 'client/core/branch';
import AddressActions from 'client/actions/Address';
import UtilityAuthActions from 'client/actions/UtilityAuth';
import UtilityPartnerActions from 'client/actions/UtilityPartner';

import SrUtilitySetupPage from 'client/components/SrUtilitySetup/SrUtilitySetupPage';
import SrUtilitySetupSignup from 'client/components/SrUtilitySetup/SrUtilitySetupSignup';
import requestUtilityApi from 'client/actions/requestUtilityApi';

@withTransitionHook
@withLocationQuery
@withScreenId(SCREEN_ID_UTILITY_SETUP_SIGNUP)
@withScrollToTop
@branch(({ match }) => ({
  address: ['addresses', 'byId', match.params.addressId],
  utilityPartner: ['utilityPartners', 'bySlug', match.params.partnerSlug],
  utilitySetupSignupApiState: ['apiState', SR_API_ACTION_UTILITY_USER_SIGNUP, 'default'],
  utilityUser: ['utilityUser'],
}))
class UtilitySetupSignupPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Utility Setup | Signup',
  });

  static fetchData(match, inject) {
    const addressId = parseInt(match.params.addressId, 10);

    if (isNaN(addressId)) {
      return;
    }

    return Promise.all([
      UtilityPartnerActions.getBySlug(inject, {
        slug: match.params.partnerSlug,
      }),
      AddressActions.getById(inject, {
        addressId: addressId,
      }),
    ]);
  }

  _onSubmit = (formValues) => {
    const { dispatch, history, address, utilityPartner, locationQuery, match } = this.props;

    const isTenantScreeningPartner =
      utilityPartner?.customerType === UTILITY_PARTNER_CUSTOMER_TYPE_TENANT_SCREENING;

    const isGooglePlaceId = isNaN(parseInt(match.params.addressId, 10));

    const addressId = isGooglePlaceId ? null : parseInt(match.params.addressId, 10);

    const unitNumber = isTenantScreeningPartner ? locationQuery.unitNumber : null;

    if (isGooglePlaceId) {
      return dispatch(requestUtilityApi, {
        action: SR_API_ACTION_ADDRESS_REGISTER,
        payload: {
          utilityPartnerId: utilityPartner.id,
          googlePlaceId: match.params.addressId,
          unitNumber,
        },
        onSuccess: (newActivation) => {
          dispatch(UtilityAuthActions.userSignup, {
            address: {
              ...newActivation,
              unitNumber,
            },
            utilityPartnerId: utilityPartner.id,
            ...formValues,
          }).then(({ user }) => {
            if (user) {
              history.push('/utility-setup/session');
            }
          });
        },
      });
    }

    return dispatch(UtilityAuthActions.userSignup, {
      address: {
        ...address,
        ...(isTenantScreeningPartner ? { googlePlaceId: addressId, unitNumber } : {}),
      },
      utilityPartnerId: utilityPartner.id,
      ...formValues,
    }).then(({ user }) => {
      if (user) {
        history.push('/utility-setup/session');
      }
    });
  };

  render() {
    const { match, address, utilityUser, utilityPartner, utilitySetupSignupApiState } = this.props;

    const isTenantScreeningPartner =
      utilityPartner?.customerType === UTILITY_PARTNER_CUSTOMER_TYPE_TENANT_SCREENING;

    if (utilityUser?.id && hasRoleRenter(utilityUser?.roles || [])) {
      return <Redirect to="/utility-setup/session" />;
    }

    if (isNaN(parseInt(match.params.addressId, 10)) && !isTenantScreeningPartner) {
      return <Redirect to={`/utility-setup/${match.params.partnerSlug}`} />;
    }

    return (
      <SrUtilitySetupPage
        address={address}
        logoUrl={utilityPartner.logoUrl}
        backButtonText="Back"
        backButtonUrl={`/utility-setup/${utilityPartner.slug}`}
      >
        <SrUtilitySetupSignup
          utilityUser={utilityUser || {}}
          utilityPartner={utilityPartner}
          onSubmit={this._onSubmit}
          apiState={utilitySetupSignupApiState}
        />
      </SrUtilitySetupPage>
    );
  }
}

UtilitySetupSignupPage.displayName = 'UtilitySetupSignupPage';

export default UtilitySetupSignupPage;
